import * as _ from "lodash";
import React, {Fragment} from 'react';
import {
    Grid,
    Card,
    TextField,
    FormHelperText
} from "@material-ui/core";
import _isEqual from "lodash/isEqual";
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import {priceFormChange, resetPriceForm} from "../../../vendors/actions/case";
import InputMask from "react-input-mask";

import MuiAlert from "@material-ui/lab/Alert/Alert";


interface OwnProps {
    priceFormChange?: any
    resetPriceForm?: any

    [key: string]: any
}

interface MainState {
    prices: Array<{
        [key: string]: any
    }>,
    caseType: {} | null,
    selected: string | null
}

interface ConnectStateProps {
    CaseForm: any
}

interface ConnectDispatchProps {
    priceFormChange?: (data: any) => void;
    resetPriceForm?: (data: any) => void;
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;

const props: {
    [key: string]: any
} = {
    "full_case_flat": {
        price: '!!price!!',
        coefficient: null,
        title: 'Take on the Full Case',
        subTitle: 'Flat fee',
        error: null
    },
    /* "full_case_hourly": {
         price: '!!price!!',
         coefficient: 10,
         title: "Take on the Full Case",
         subTitle: "Hourly",
         error: null
     },*/
    "single_appearance": {
        price: '!!price!!',
        coefficient: null,
        title: "Single Appearance",
        subTitle: "Coverage",
        error: null
    },
    "contingency": {
        price: 'Contingency \n Basis',
        coefficient: null,
        title: "Fees to be determined with \n the matched lawyer.",
        error: null
    },
    "pro_bono": {
        price: 'Pro Bono\nBasis',
        coefficient: null,
        title: "No Lawyer’s Fees\n (Limited Availability)",
        error: null
    }
};

const infoNotes: { [key: string]: any } = {
    "full_case_flat": `The case or legal task you have requested will be done for a 
                               single flat fee of $!!price!! when matched with a lawyer.`,
    /* "full_case_hourly": `Cases paid on an hourly basis require a retainer for a minimum of 10 hours.
                                Unused portions will be prorated and refunded. You will be charged $!!price!!.`,*/
    "single_appearance": `The fee for a single appearance covers one hearing or court visit. 
                              The lawyer will not take the full scope of your matter/case.`,
    "contingency": `Cases offered on Contingency Basis require the lawyer and the consumer to establish
                              the terms of their collaboration independently and outside of the AppearMe network.`,
    "pro_bono": `Lawyers on our network often choose to offer their services on a Pro Bono Basis, i.e. “without charge”. 
        You MUST submit explanation and supporting documents as to why you qualify for pro bono legal services to be considered.`
};

const pricesMutation = (data: any) => {
    const properties = _.cloneDeep(props);
    const key = Object.keys(data)[0];
    properties[key].price = properties[key].price.replace('!!price!!', data[key]);
    properties[key].base = _.cloneDeep(properties[key].price);
    properties[key].coefficient = _.cloneDeep(properties[key].coefficient);
    properties[key].key = key;
    return properties[key];
};

const priceFormat = (props: any) => {
    const {...other} = props;
    return (
        <InputMask
            {...other}
            placeholder={''}
            alwaysShowMask={true}
            mask="$999999"
            maskChar=""
        />
    )
};


class PriceForm extends React.Component<HeaderProps, MainState> {
    state = {
        prices: [] as any,
        caseType: null,
        selected: ''
    };

    private priceBoxRef: any = React.createRef<HTMLDivElement>();

    componentWillUnmount(): void {
        this.props.resetPriceForm()
    }

    static getDerivedStateFromProps(props: any, state: any) {
        const {CaseForm, PriceForm: priceForm, resetPriceForm} = props;
        const caseType = CaseForm.data.caseType.value;
        if (!_isEqual(state.caseType, caseType)) {
            const prices = PriceForm.initPrices(caseType);
            resetPriceForm();
            return {
                prices: prices.map(price => pricesMutation(price)),
                caseType,
                selected: null
            }
        }

        if (!_isEqual(state.selected, priceForm.data.payment_type.value)) {
            return {
                selected: priceForm.data.payment_type.value
            }
        }

        if (state.selected && state.prices.length) {
            const priceObj = state.prices.find((p: any) => p.key === state.selected);
            priceObj.error = priceForm.data.price.error;
        }

        if (!_isEqual(state.form, priceForm.data)) {
            return {
                form: priceForm.data
            };
        }
        return null;
    }

    componentDidUpdate(prevProps: any, prevState: any) {

        if (!_isEqual(prevState.selected, this.state.selected)) {
            this.focusOnSelect()
        }
    }

    private static initPrices(caseType: any) {
        const prices = [];
        if (!caseType) {
            return [];
        }
        const {full_case_flat, single_appearance, contingency, pro_bono} = caseType;
        if (full_case_flat >= 0) {
            prices.push({full_case_flat})
        }
        /*
           if (full_case_hourly >= 0) {
             prices.push({full_case_hourly})
         }*/
        if (single_appearance >= 0) {
            prices.push({single_appearance})
        }
        if (contingency >= 0) {
            prices.push({contingency})
        }
        if (pro_bono >= 0) {
            prices.push({pro_bono})
        }
        return prices;
    }

    selectPrice(data: any, e: any) {
        if (!data) return;
        if (data.key !== this.state.selected) {
            this.resetPrices()
        }

        this.changePrice(data, e);
    };

    resetPrices() {
        const prices = this.state.prices.map((p: any) => {
            p.price = p.base;
            p.error = null;

            return p;
        });
        this.setState({selected: null, prices});
    }

    changePrice(data: any, e: any) {

        const contingency = data.key === 'contingency' || data.key === 'pro_bono';
        const targetVal = e ? e.target?.value : data.price;

        const value = contingency ? 0 : Number.isInteger(targetVal) ? targetVal : parseInt(targetVal.replace(/\D+/g, '') || '0');
        data.price = !contingency ? value : data.price;

        this.props.priceFormChange({value: data.key, base: data.base, field: 'payment_type'});
        this.props.priceFormChange({
            value: contingency ? 0 : value,
            coefficient: data.coefficient,
            subfield: data.key,
            field: 'price',
            base: contingency ? 0 : data.base,
        });
    }

    focusOnSelect() {
        const priceInput = this.priceBoxRef.querySelector('.selected .price input');
        priceInput && priceInput.focus();
    }

    render() {
        const {prices, selected} = this.state;
        const {PriceForm} = this.props;
        const list = prices.map((data: any, key: number) => {
            return (
                <Grid key={key} item xs={12} sm={6} md={6}>
                    <Card
                        onClick={(e) => data.key !== selected && this.selectPrice(data, null)}
                        className={
                            `card-box text-black-50 mb-4 p-3 d-flex cons-price 
                            ${data.key} ${selected && (data.key === selected) ? 'selected' : ''}
                            ${!!PriceForm?.data?.payment_type?.error ? 'error' : ''}
                        `}>
                        <div className="price">
                            {data.key !== 'contingency' && data.key !== 'pro_bono' && <TextField
                                className={'w-75'}
                                value={data.key === selected ? PriceForm?.data?.price?.value || '' : data.price || ''}
                                error={!!data?.error}
                                helperText={data?.error}
                                onChange={(e) => this.changePrice(data, e)}
                                id={data.key}
                                key={data.key}
                                InputProps={{
                                    inputComponent: priceFormat,
                                }}
                                variant="outlined"
                            />}
                            {(data.key === 'contingency' || data.key === 'pro_bono') && data.price}
                        </div>
                        <div style={{marginBottom: '8px'}}
                             className="divider mt-2 border-2 w-50 bg-first rounded border-primary"/>
                        <div className="title">{data.title}</div>
                        {data.subTitle && <div className="sub-title">{data.subTitle}</div>}
                    </Card>
                </Grid>
            )
        });
        return (
            <Fragment>
                <Grid ref={ref => this.priceBoxRef = ref} container spacing={4}>
                    {list}
                </Grid>
                <div>
                    <FormHelperText className={`text-left`}
                                    error={!!PriceForm?.data?.payment_type?.error}>{PriceForm?.data?.payment_type?.error}</FormHelperText>
                </div>
                {selected && <MuiAlert className="mb-4 mt-2" severity="info">
                    <div className="d-flex align-items-center align-content-center">
                          <span>
                              {infoNotes[selected]
                                  .replace('!!price!!', PriceForm.data.price.coefficient ?
                                      (PriceForm.data.price.coefficient * PriceForm.data.price.value) : PriceForm.data.price.value)}
                          </span>
                    </div>
                </MuiAlert>}
            </Fragment>
        )
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {CaseForm, PriceForm} = state;
    return {
        CaseForm,
        PriceForm
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        priceFormChange: (data: any) => dispatch(priceFormChange(data)),
        resetPriceForm: (data: any) => dispatch(resetPriceForm()),
    }
};


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(PriceForm);
